<!-- Steps 步骤条 -->
<template>
  <div class="steps-container">
    <!--正常订单的叮当执行步骤图
      @pram state 0：待支付，1 进行中 2待评价（服务中点击已完成后状态为待评价等同已完成） 3：交易全部完成（评价完成后的状态）， 6服务中 ), (-2 已申请等待商家处理（已申请退款）-3已同意(退款中) -4拒绝退款 )-->
    <el-steps :active="changeActive(data)" align-center finish-status="success"
              v-if="data.state == 0 || data.state == 1 || data.state == 2 || data.state == 3 || data.state == 6">
      <el-step title="提交订单" :description="timestampToTime(data.applictionTime)"></el-step>
      <el-step title="打款支付" :description="timestampToTime(data.payTime)"></el-step>
      <el-step title="进行服务" :description="data.startTime!='0000-00-00 00:00:00' ? data.startTime : ''"></el-step>
      <el-step title="确定完成" :description="timestampToTime(data.completeTime)"></el-step>
      <el-step title="评价" :description="timestampToTime(data.evaluateTime)"></el-step>
    </el-steps>
    <!--售后退款的订单执行步骤图
      @pram state 状态 -2 已申请（退款中）-3已同意退款() -4拒绝退款-->
    <el-steps :active="changeActive(data)" align-center finish-status="success" v-else-if="data.state==-2 || data.state==-3">
      <el-step title="提交订单" :description="timestampToTime(data.applictionT)"></el-step>
      <el-step title="商家审核" :description="timestampToTime(data.agreeRefundTime)"></el-step>
      <el-step title="商家打款" :description="timestampToTime(data.refundT)"></el-step>
      <el-step title="退款到账" :description="timestampToTime(data.paymentDate)"></el-step>
    </el-steps>
  </div>
</template>

<script>
export default {
  name: "orderProcess",
  data() {
    return {
      active: 0,
    }
  },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  methods: {
    /*时间戳转换*/
    timestampToTime(timestamp) {
      if (timestamp != '' && timestamp != undefined && timestamp != 0 && timestamp != null) {
        let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        let Y = date.getFullYear() + "-";
        let M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-";
        let D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
        let h = (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
        let m = (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) + ":";
        let s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        return Y + M + D + h + m + s;
      } else
        return '';
    },
    /*匹配步骤*/
    changeActive(data){
      if (data.state == 0) {
        return 1
      } else if (data.state == 2) {
        return 4
      } else if (data.state == 1) {
        return 2
      } else if (data.state == 6) {
        return 3
      } else if (data.state == 3) {
        return 5
      } else if (data.state == -2) {
        return 2
      } else if (data.state == -3) {
        return 4
      }
    }
  },
  mounted() {}
}
</script>
<style scoped>
.steps-container >>> .el-step__icon-inner.is-status {
  transform: translateY(0px) translateX(0px);
  border-radius: 50%;
  border: none;
  background: #FE273B;
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.steps-container >>> .el-step__icon {
  width: 48px;
  height: 48px;
  font-size: 20px;
  color: #ffffff;
  background: #DDDDDD;
  border: none;
}

.steps-container >>> .el-step.is-horizontal .el-step__line {
  top: 14px;
}

.steps-container >>> .el-step__icon.is-text {
  margin-top: 35px;
}

.steps-container >>> .el-step__title {
  margin-top: -85px;
  /*font-family: 'SourceHanSansCN';*/
}

.steps-container >>> .el-step__description {
  margin-top: 55px;
  color: #999999;
  font-size: 14px;
  width: 80px;
}

.steps-container >>> .el-step.is-center .el-step__line {
  margin-top: 45px;
  height: 4px;
}

.steps-container >>> .el-step__title.is-success {
  color: #FD2F37;
  font-size: 14px;
}

.steps-container >>> .el-step__title.is-process {
  font-weight: normal;
  color: #AAAAAA;
  font-size: 14px;
}

.steps-container >>> .el-step__title.is-wait {
  font-weight: normal;
  color: #AAAAAA;
  font-size: 14px;
}

.steps-container >>> .el-step__description.is-success {
  color: #999999;
  font-size: 14px;
  width: 80px;
}

.steps-container >>> .el-step__line {
  background-color: #DDDDDD;
  height: 4px;
}

.steps-container >>> .el-step__line-inner {
  border-color: #FE273B;
  height: 4px;
  border-width: 2px !important;
}

.steps-container >>> .el-step.is-center .el-step__description {
  padding-left: 33%;
}
</style>
<style scoped lang="scss">
.steps-container {

}
</style>